module.exports = __webpack_public_path__ + "static/Reading-Small-509585578dc235211588ee5686956a7c.png";